module.exports = __webpack_public_path__ + "img/btn_right_d.2a8a3d83.png";